export const DropArea = {
  mounted() {
    this.showOverlay = this.showOverlay.bind(this);
    this.hideOverlay = this.hideOverlay.bind(this);

    this.syncListeners();
  },

  updated() {
    this.syncListeners();
  },

  destroyed() {
    this.detachListeners();
  },

  syncListeners() {
    const disabled = this.el.dataset.disabled === "true";

    if (disabled) {
      this.detachListeners();
      return;
    }

    if (this.attached) return;

    this.el.addEventListener("dragover", this.showOverlay);
    this.el.addEventListener("dragenter", this.showOverlay);
    this.el.addEventListener("dragleave", this.hideOverlay);
    this.el.addEventListener("drop", this.hideOverlay);
    this.attached = true;
  },

  detachListeners() {
    if (!this.attached) return;
    this.el.removeEventListener("dragover", this.showOverlay);
    this.el.removeEventListener("dragenter", this.showOverlay);
    this.el.removeEventListener("dragleave", this.hideOverlay);
    this.el.removeEventListener("drop", this.hideOverlay);
    this.attached = false;
  },

  getOverlay() {
    return this.el.querySelector(`#${this.el.dataset.dropOverlay}`);
  },

  showOverlay() {
    const overlay = this.getOverlay();
    if (!overlay) return;
    overlay.classList.add("opacity-100");
    overlay.classList.remove("opacity-0");
  },

  hideOverlay() {
    const overlay = this.getOverlay();
    if (!overlay) return;
    overlay.classList.add("opacity-0");
    overlay.classList.remove("opacity-100");
  },
};
